export const getRoleLandingPath = (role) => {
  switch (role) {
    case 'kiosk':
      return '/kiosk/register';
    case 'owner':
    case 'admin':
      return '/orders/dashboard';
    case 'manager':
    case 'staff':
      return '/orders';
    case 'production':
      return '/garments';
    default:
      return '/orders';
  }
};
